module.exports = __webpack_public_path__ + "static/media/Acrilico (25).4c5c892b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/Acrilico (25).jpg
// module id = 293
// module chunks = 0